import FR from './fr.json';
import SV from './sv.json';

export const messages = {
  SV,
  FR
};
